export * from '@white-label-store/search-box';
